// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","banner":"_350mOOaaw3b_fyTbZYyypl","displayItem":"_3JZWz4tFcH6cIzVHeGVOVq"};